export class SourceSizeCheckResult {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "ok",
            "baseName": "ok",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "hasMinimum",
            "baseName": "hasMinimum",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "sourceSizeGb",
            "baseName": "sourceSizeGb",
            "type": "number",
            "format": "double"
        },
        {
            "name": "minimumSizeGb",
            "baseName": "minimumSizeGb",
            "type": "number",
            "format": "double"
        },
        {
            "name": "error",
            "baseName": "error",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SourceSizeCheckResult.attributeTypeMap;
    }
    constructor() {
    }
}
